<template>
<div>
    <div class="navbar">
        <div class="center-column">
        <!-- <router-link to="/explorer" tag="a" class="nav-item">Explore</router-link> -->
        <div class="nav-w-icon">
            <a class="nav-item link" href="https://arxiv.org/abs/2111.06247" target="_blank">
            <img src="../assets/images/preprint.svg" width=20 alt="github icon">
            Arxiv preprint</a>
        </div>
        <div class="nav-w-icon">
            <a class="nav-item link" href="https://github.com/joshbiology/gene_fn" target="_blank">
            <img src="../assets/images/github.png" width=25 alt="github icon">
            Code for paper</a>
        </div>
        <div class="nav-w-icon">
            <a class="nav-item link" href="https://github.com/joshbiology/graph_dictionary_learning" target="_blank">
            <img src="../assets/images/github.png" width=25 alt="github icon">
            Dictionary learning code</a>
        </div>
        <div class="nav-w-icon">
            <a class="nav-item link" href="https://doi.org/10.6084/m9.figshare.14963561" target="_blank">
            <img src="../assets/images/figshare.png" width=25 alt="figshare icon">
            Figshare data</a>
        </div>
        <div class="nav-w-icon">
            <a class="nav-item link" href="https://medium.com/@patternvizlab/introducing-a-novel-approach-to-3d-umap-visualization-for-single-cell-genomic-analysis-b79cf09f1af6" target="_blank">
            <img src="../assets/images/medium-logo.png" width=25 alt="medium icon">
            Design write-up</a>
        </div>
        </div>
    </div>
</div>
</template>

<script>
    export default {
        name: "NavBar"
    }
</script>

<style scoped>
    a[target="_blank"]:after {
        content: none;
        margin: 0 3px 0 5px
    }

    .nav-w-icon {
        display: inline;
        margin-left: 6px;
    }

    .nav-w-icon img {
        padding-right: 5px;
        vertical-align: middle;
    }

    .navbar {
        border-bottom: solid 1px rgb(199, 199, 199);
        width: 100%;
        background-color: white;
        z-index: 1800;
        padding-top: 12px;
        padding-bottom: 5px
    }

    .nav-item {
        margin-right: 15px;
        display: inline-block;
    }

    .link {
        font-size: 18px;
        color: rgb(82, 82, 82);
    }

    .vertdivider {
        display: inline-block;
        color: black;
        margin-right: 10px;
        font-size: 12pt;
        font-weight: 300;
    }
    a {
        text-decoration: none;
        border-bottom: 0pt solid transparent;
        color: black;
    }
    a:hover {
        padding-bottom: 0px;
        border-bottom: solid 1px hotpink;
    }

    .router-link-exact-active {
        text-decoration: none;
        border-bottom: 1pt solid hotpink;
        padding-bottom: 3px;
        color: black;
    }


</style>